export default __webpack_public_path__ + "static/media/loading.8ce4ea74.gif";